/* eslint-disable camelcase */
// eslint-disable-next-line consistent-return
export const addCss = (cssString) => {
	const existingStyle = document.getElementById('jobchatStyle');
	if (existingStyle) {
		existingStyle.innerHTML = cssString;
		return existingStyle;
	}

	const style = document.createElement('style');
	style.id = 'jobchatStyle';
	style.type = 'text/css';
	style.rel = 'stylesheet';
	style.innerHTML = cssString;
	document.head.appendChild(style);
	// for consistent return
	/* eslint-disable-next-line no-undefined */
};

/**
 * Admin app uses different language codes that are not per ISO specs.
 * This object is to map the admin-app's language codes to ISO language codes.
 */
const languageMappingObj = {
	en: 'en-US',
	'en-GB': 'en-GB',
	'fr-CA': 'fr-CA',
	'fr-FR': 'fr-FR',
	de: 'de-DE',
	nl: 'nl-BE',
	el: 'el-GR',
	'es-ES': 'es-ES',
	'es-419': 'es-MX',
	it: 'it-IT',
	'zh-CN': 'zh-CN',
	'zh-TW': 'zh-TW',
	ja: 'ja-JP',
	'cs-CZ': 'cs-CZ',
	ko: 'ko-KR',
	ms: 'ms-MY',
	pl: 'pl-PL',
	'pt-PT': 'pt-PT',
	ro: 'ro-RO',
	ru: 'ru-RU',
	sv: 'sv-SE',
	th: 'th-TH',
	'ro-RO': 'ro-RO',
	'ms-MY': 'ms-MY',
	'tr-TR': 'tr-TR',
	'uk-UA': 'uk-UA',
	'bg-BG': 'bg-BG',
	'da-DK': 'da-DK',
	'fi-FI': 'fi-FI',
	'id-ID': 'id-ID',
	'sr-RS': 'sr-RS',
};

export const getLanguageCode = (language) =>
	languageMappingObj[language] ? languageMappingObj[language] : 'en-US';

// Temp solution. Should be moved to reactive-p or redux. -Amir
export const ariConfig = { displayName: 'ARI', imgUrl: '', imgAlt: '' };

class Messenger {
	constructor() {
		this.sendMessageToWidget = this.sendMessageToWidget.bind(this);
	}
	/**
	 * Sends data from the react-app to the chat widget.
	 * We're using window.parent since the react-app is running inside of an iframe.
	 * @param {String} action => acts as a key for identified message passing
	 */
	sendMessageToWidget({ action, additionalData }) {
		window.parent.postMessage({ action, ...additionalData }, '*');
	}
}

export const AppMessenger = new Messenger();
